import React from 'react';
import Login from 'login';
import UserPortal from 'userportal';
import { Route, Switch } from 'react-router-dom';
import SecureRoute from 'secure-route';
import styles from './index.scss';



const App = () => {



  return (<div className={ styles.appWrapper }>

    
    <Switch> 
      
      <Route path="/login" component={ Login }/>
      
      <SecureRoute component={ UserPortal } />
    
    </Switch>
  </div>);

  
}



export default App;


// WEBPACK FOOTER //
// ./src/app/index.jsx